import React from 'react'
import { HoroscopeData } from 'component-library/content/Horoscope/Horoscope'
import loadable from '@loadable/component'
import { AdUnitInformation } from 'component-library/advertising/advertising.routing'
import {
    createRegisterableComponentWithData,
    ComponentServices,
} from 'common/routing/page-definition'
import { DataDefinition } from 'json-react-layouts-data-loader'
import { AdUnitWrapper } from 'component-library/advertising/AdUnit/AdUnitWrapper'

const LazyHoroscope = loadable(() => import('component-library/content/Horoscope/Horoscope'))

export type HoroscopeDataDefinition = DataDefinition<{}, HoroscopeData, ComponentServices>

export const HoroscopeDataDefinitionLoader: HoroscopeDataDefinition = {
    loadData: (props, services) =>
        fetch(`${services.config.contentApi}/assets/horoscopes/horoscopes.json`)
            .then(async result => {
                if (result.status !== 200) {
                    throw new Error('Failed to load horoscopes ' + props)
                }

                return result.json()
            })
            .then(horoscopeResponse => {
                return {
                    date: horoscopeResponse.date,
                    thought: horoscopeResponse.thought,
                    horoscopes: horoscopeResponse.horoscopes,
                }
            }),
}

export interface HoroscopeRouteProps {
    inlineContentAds: Array<AdUnitInformation['data']>
}

export const HoroscopeRegistration = createRegisterableComponentWithData(
    'horoscope',
    HoroscopeDataDefinitionLoader,
    (props: HoroscopeRouteProps, data, services) => {
        const adUnits = props.inlineContentAds.map(ad => (
            <AdUnitWrapper
                {...ad}
                key={ad.slot.id}
                adState={services.adState}
                unitId={ad.slot.id}
                onEvent={services.onEvent}
            />
        ))

        if (!data.loaded) {
            return null
        }

        return (
            <LazyHoroscope
                data={data.result}
                inlineContentAds={adUnits}
                onEvent={services.onEvent}
            />
        )
    }
)
